<script setup lang="ts">
import { useReferralStore } from '~/stores/referral'

const props = defineProps<{
  caption: string
  src: string
  imgAlt: string
}>()

const store = useReferralStore()
</script>

<template>
  <figure :class="store.isFromReferral ? 'lg:flex-wrap' : ''" class="w-fit mx-auto flex flex-col items-start lg:flex-row">
    <img
      :src="props.src" class="xs:mx-auto w-[120px] h-[120px] lg:w-[80px] lg:h-[80px]"
      :class="store.isFromReferral ? 'lg:!w-[120px] lg:!h-[120px] lg:mx-auto' : ''" :alt="props.imgAlt"
    >
    <figcaption class="text-center my-[12px] lg:text-left  lg:ml-24 text-sm">
      {{ props.caption }}
    </figcaption>
  </figure>
</template>
